import MediaCapture from '../components/MediaCapture.tsx';
import FixLoading from '../layout/FixLoading';

const PosIndexPage = () => {
    return (
        <FixLoading>
            <MediaCapture />
        </FixLoading>
    );
};

export default PosIndexPage;
